export default "__VITE_ASSET__CpAabX3x__"